// zapiet-PREDICTIVESEARCH-Badge.js
// Clean production version: no console logs, full badge logic, gray-out, mutation observer

(function () {

  function injectBadge(card, text, cls) {
    try {
      const imgWrap =
        card.querySelector(".t4s-search-fullwidth__image") || card;

      if (getComputedStyle(imgWrap).position === "static") {
        imgWrap.style.position = "relative";
      }

      let badge = imgWrap.querySelector(".zapiet-badge");
      if (!badge) {
        badge = document.createElement("div");
        badge.className = "zapiet-badge";
        imgWrap.prepend(badge);
      }

      badge.textContent = text;
      badge.className = `zapiet-badge ${cls}`;
    } catch (e) {}
  }

  function grayOutCard(card) {
    try {
      card.classList.add("pred-disabled");

      const link = card.querySelector("a");
      if (link) {
        link.style.pointerEvents = "none";
        link.style.opacity = "0.5";
      }

//      card.style.opacity = "0.5";
  //    card.style.filter = "grayscale(1)";
    } catch (e) {}
  }

  function addStyleOnce() {
    if (document.getElementById("predictive-badge-style")) return;

    const st = document.createElement("style");
    st.id = "predictive-badge-style";
    st.innerHTML = `
      .zapiet-badge {
        font-weight:500;
        padding:4px 6px;
        font-size:11px;
        position:absolute;
        top:8px;
        left:5px;
        border-radius:3px;
        z-index:10;
        pointer-events:none;
        color:#fff;
        min-width:64px;
        text-align:center;
        line-height:1;
        box-shadow:0 2px 6px rgba(0,0,0,.18);
      }

      .predictive-badge-available { background:rgba(0,207,131,.97) !important; }
      .predictive-badge-limited { background:rgba(255,193,7,.92) !important; }
      .predictive-badge-unavailable { background:rgba(128,128,128,.92) !important; }
      .predictive-badge-soldout { background:rgba(128,128,128,.92) !important; }
      .predictive-badge-not-in-menu { background:rgba(128,128,128,.92) !important; }

      .pred-disabled {
        opacity: 100% !important;
        filter:grayscale(50%) !important;
        pointer-events:none !important;
      }
    `;
    document.head.appendChild(st);
  }

  function parseVariantIds(raw) {
    if (!raw) return [];
    try {
      return JSON.parse(raw).map(String);
    } catch (e) {
      try {
        return JSON.parse(raw.replace(/'/g, '"')).map(String);
      } catch (e2) {
        return (raw.match(/\d+/g) || []).map(String);
      }
    }
  }

  function runPredictiveBadges() {
    try {
      addStyleOnce();

      const cards = [...document.querySelectorAll(".predictive-card")];
      if (!cards.length) return;

      const r = window.ZapietEats?.getSelectedRestaurant?.();
      const m = window.ZapietEats?.getSelectedMenu?.();
      const dRaw = window.ZapietEats?.getSelectedDate?.();
      const vm = window.ZapietWidgetConfig?.variant_metafields;

      if (!r || !m || !dRaw || !vm) return;

      let selectedDate = null;
      try {
        const d = new Date(dRaw);
        d.setDate(d.getDate() - 1);
        selectedDate = d.toISOString().split("T")[0];
      } catch {}

      const menuVariantIds = [];
      m?.menu_sections?.forEach(sec => {
        sec?.menu_section_items?.forEach(it => {
          if (it?.product?.variant_id)
            menuVariantIds.push(String(it.product.variant_id));
        });
      });
      const menuSet = new Set(menuVariantIds);

      const deliveryOption =
        window.ZapietEats?.getDeliveryOption?.() === "pickup"
          ? "store_pickup"
          : "local_delivery";

      const restrictions =
        m?.config?.[deliveryOption]?.product_date_restrictions || [];

      const isSoldOut = (vmObj, rid, mid, date, vid) => {
        const vData = vmObj?.[vid];
        if (!vData) return false;

        const key = Object.keys(vData).find(
          k =>
            k.includes(String(rid)) &&
            k.includes(String(mid)) &&
            k.includes(date)
        );
        const inv = key ? vData[key] : null;

        return (
          inv?.toggled_off ||
          (typeof inv?.remaining === "number" && inv.remaining <= 0)
        );
      };

      const isRestricted = (restrList, vid, date) => {
        return restrList?.some(
          r =>
            String(r.variant_id) === String(vid) &&
            r.restricted_dates?.includes(date) &&
            (r.restriction_type === "deny" ||
              r.restriction_type === "DENY")
        );
      };

      cards.forEach(card => {
        const ids = parseVariantIds(card.getAttribute("data-variant-ids"));

        if (!ids.length) {
          injectBadge(card, "UNAVAILABLE", "predictive-badge-unavailable");
          grayOutCard(card);
          return;
        }

        const allNotMenu = ids.every(id => !menuSet.has(id));
        if (allNotMenu) {
          injectBadge(card, "NOT IN MENU", "predictive-badge-not-in-menu");
          grayOutCard(card);
          return;
        }

        const sold = ids.map(id =>
          isSoldOut(vm, r.id, m.id, selectedDate, id)
        );
        const restr = ids.map(id =>
          isRestricted(restrictions, id, selectedDate)
        );

        const allSold = sold.every(Boolean);
        const allRestr = restr.every(Boolean);
        const partial =
          !allSold &&
          !allRestr &&
          (sold.some(Boolean) || restr.some(Boolean));

        if (allSold) {
          injectBadge(card, "SOLD OUT TODAY", "predictive-badge-soldout");
          grayOutCard(card);
        } else if (allRestr) {
          injectBadge(card, "UNAVAILABLE", "predictive-badge-unavailable");
          grayOutCard(card);
        } else if (partial) {
          injectBadge(card, "LIMITED", "predictive-badge-limited");
        } else {
          injectBadge(card, "IN STOCK", "predictive-badge-available");
        }
      });
    } catch (e) {}
  }

  function init() {
    if (document.readyState !== "loading") {
      setTimeout(runPredictiveBadges, 60);
    } else {
      document.addEventListener("DOMContentLoaded", () =>
        setTimeout(runPredictiveBadges, 60)
      );
    }

    document.addEventListener("zapieteats:ready", runPredictiveBadges);
    document.addEventListener("zapieteats:change", runPredictiveBadges);
    document.addEventListener("predictive:updated", runPredictiveBadges);

    const obs = new MutationObserver(() => {
      if (document.querySelector(".predictive-card")) {
        setTimeout(runPredictiveBadges, 80);
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  init();
})();
